import { ListPage } from '@components/molecules';
import { TextFieldElement } from 'react-hook-form-mui';
import API from '@apps/accounts/services/user';
import { ModelProps } from '@/types';
import { UserSchema, UserSearchSchema } from '@apps/accounts/schemas/user';
import { GridColDef } from '@mui/x-data-grid';
import { JSX } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { YesNoAutocompleteElement } from '@/components/atoms';

export default function ObjectListPage(modelProps: ModelProps): JSX.Element {
  const { t } = useTranslation();
  const columns: GridColDef[] = [
    {
      field: 'email',
      headerName: t('Email'),
      flex: 1,
    },
    {
      field: 'first_name',
      headerName: t('First Name'),
      flex: 1,
    },
    {
      field: 'last_name',
      headerName: t('Last Name'),
      flex: 1,
    },
    {
      field: 'is_active',
      headerName: t('Is Active?'),
      type: 'boolean',
    },
    {
      field: 'is_superuser',
      headerName: t('Is Superuser?'),
      type: 'boolean',
      width: 150,
    },
  ];

  return (
    <ListPage
      disableAdd
      disableDelete
      schema={UserSchema}
      schemaSearch={UserSearchSchema}
      title={t('User')}
      api={API}
      columns={columns}
      modelProps={modelProps}
      initialState={{
        sorting: {
          sortModel: [{ field: 'email', sort: 'asc' }],
        },
      }}
    >
      <Grid size={{ xs: 12, md: 3 }}>
        <TextFieldElement name="search" label={t('Search')} fullWidth />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <YesNoAutocompleteElement name="is_active" label={t('Is Active?')} />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <YesNoAutocompleteElement
          name="is_superuser"
          label={t('Is Superuser?')}
        />
      </Grid>
    </ListPage>
  );
}
